import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectActiveTemplateId } from '../selectors';
const getActiveProjectTemplate = ()=>createSelector((state)=>state.templates.project, (_, templateId)=>templateId, (project, templateId)=>{
        var _project_data_templateId;
        return (_project_data_templateId = project.data[templateId]) === null || _project_data_templateId === void 0 ? void 0 : _project_data_templateId.template;
    });
export const useActiveTemplateId = ()=>{
    return useSelector(selectActiveTemplateId);
};
// NOTE: cast above is a known type lie — the return can be undefined when
// the template hasn't loaded yet or activeId points at a deleted template.
// 23+ consumers currently treat the result as always-defined; tightening the
// type to `ProjectTemplate | undefined` is a separate cleanup PR (would
// surface TS errors across all callers and require auditing each one).
// For now consumers must defensively guard with `if (!template) return null`
// before reading fields off the result.
export const useActiveProjectTemplate = ()=>{
    const activeId = useActiveTemplateId();
    const templateObject = useMemo(getActiveProjectTemplate, []);
    return useSelector((state)=>templateObject(state, activeId));
};
export const useActiveProjectTemplateStore = ()=>{
    const activeId = useActiveTemplateId();
    return useSelector((state)=>state.templates.project.data[activeId]);
};
